import EligibilityBlock from '../../strapiBlocks/EligibilityBlock/EligibilityBlock';
import IncludeBlock from '../../strapiBlocks/IncludeBlock/IncludeBlock';
import StepsBlock from '../../strapiBlocks/StepsBlock/StepsBlock';
import InfoBlock from '../../strapiBlocks/InfoBlock/InfoBlock';
import GamesBlock from '../../strapiBlocks/GamesBlock/GamesBlock';
import DropDownBlock from '../../strapiBlocks/DropDownBlock/DropDownBlock';
import ConditionsBlock from '../../strapiBlocks/ConditionsBlock/ConditionsBlock';
import TournamentBlock from '../../strapiBlocks/TournamentBlock/TournamentBlock';
import EidBlock from '../../strapiBlocks/EidBlock/EidBlock';
import SignUpBlock from 'Components/strapiBlocks/SignUpBlock/SignUpBlock';
import { useSelector } from 'react-redux';
import { IApplicationState } from '@spinwise/spinwise-core';
import TableBlock from 'Components/strapiBlocks/TableBlock/TableBlock';
import CustomBonusTable from 'Components/strapiBlocks/CustomBonusTable/CustomBonusTable';
import RewardBlock from '../../strapiBlocks/RewardBlock/RewardBlock';
import OneGameBlock from 'Components/strapiBlocks/OneGameBlock/OneGameBlock';

const getBlockComponent = ({ __component, ...rest }, index) => {
  let Block;

  switch (__component) {
    case 'promo.include-block':
      Block = IncludeBlock;
      break;
    case 'promo.steps-block':
      Block = StepsBlock;
      break;
    case 'promo.eligibility-block':
      Block = EligibilityBlock;
      break;
    case 'promo.info-block':
      Block = InfoBlock;
      break;
    case 'promo.games-block':
      Block = GamesBlock;
      break;
    case 'promo.tournament-block':
      Block = TournamentBlock;
      break;
    case 'promo.dropdown-block':
      Block = DropDownBlock;
      break;
    case 'promo.conditions-block':
      Block = ConditionsBlock;
      break;
    case 'promo.eid-block':
      Block = EidBlock;
      break;
    case 'promo.sign-up-block':
      Block = SignUpBlock;
      break;
    case 'promo.table-block':
      Block = TableBlock;
      break;
    case 'promo.custom-bonus-table':
      Block = CustomBonusTable;
      break;
    case 'promo.reward-block':
      Block = RewardBlock;
      break;
    case 'promo.one-game-block':
      Block = OneGameBlock;
      break;
  }

  return Block ? <Block key={`index-${index}`} {...rest} /> : null;
};

const BlockManager = ({ blocks = [] }) => {
  const { success } = useSelector((state: IApplicationState) => state.authReducer.auth);

  const result = blocks.filter(
    block => block.auth_switch?.authenticated == null || block.auth_switch.authenticated == success,
  );
  return <div>{result.map(getBlockComponent)}</div>;
};

export default BlockManager;
